<template>
	<v-btn
		outlined
		color="#919191"
		height="20"
		rounded
		class="as_btn"
		depressed
		v-if="asyncRunAfterAllPrevious || asyncRunBeforeAllFollowing || forceShow"
	>
		<span>I Async</span>
		<SIcon name="async-down" class="pr-2 pl-1" v-if="asyncRunAfterAllPrevious" />
		<SIcon name="async-up" v-if="asyncRunBeforeAllFollowing" :class="{ 'pl-1': !asyncRunAfterAllPrevious }" />
	</v-btn>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'AsyncIcon',
	props: {
		forceShow: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		asyncRunBeforeAllFollowing() {
			return this.editNode.async_before_all_following_flag;
		},
		asyncRunAfterAllPrevious() {
			return this.editNode.async_run_after_all_previous_flag;
		},
	},
};
</script>

<style scoped>
.as_btn {
	color: #292829 !important;
	font-weight: 300 !important;
	font-size: 13px !important;
	letter-spacing: 0em !important;
	border-color: #919191 !important;
}
</style>
